
export const getGSAPSettings = (container) => {
    const duration = parseFloat(container.getAttribute('vdx-gsap-duration')) || 0.5;
    const stagger = parseFloat(container.getAttribute('vdx-gsap-stagger')) || 0.1;
    const ease = container.getAttribute('vdx-gsap-ease') || 'power1.out';   
    const disableBreakpoint = parseInt(container.getAttribute('vdx-gsap-disable')) || 0;
    const threshold = parseFloat(container.getAttribute('vdx-gsap-threshold')) || 0.2;
    return { duration, stagger, ease, disableBreakpoint, threshold };
}